import { renameFile } from '@trqk/utils';

export const getAvatarKey = (userId: Maybe<string>, file: File): string => {
    if (userId !== null) {
        return renameFile(file.name, `${userId}/${userId}-avatar`);
    }

    return renameFile(file.name, `anonymous/${Date.now()}-avatar`);
};
